import { render } from "./KnowhowTip6.vue?vue&type=template&id=7262374c"
import script from "./KnowhowTip6.vue?vue&type=script&lang=js"
export * from "./KnowhowTip6.vue?vue&type=script&lang=js"

import "./KnowhowTip6.vue?vue&type=style&index=0&id=7262374c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__